import UNINITIALISED from "utils/uninitialised";
import {MaybeUninitialised} from "modules/redux_types";
import {GetLlmRunsBatchScoresAction} from "../actions/llm_runs_batch_scores_fetch";
import actionTypes from "../constants/action_types";
import {LlmRunScore} from "common/flowmaster/types/llm_run";
import {ClearLlmRunsAction} from "../actions/llm_runs_clear";

export default function batchScoresReducer(
  state: MaybeUninitialised<LlmRunScore[]> = UNINITIALISED,
  action: GetLlmRunsBatchScoresAction | ClearLlmRunsAction,
): typeof state {
  if (action.type === actionTypes.LLM_RUNS_BATCH_SCORES_FETCH.SUCCESS) {
    return (action as GetLlmRunsBatchScoresAction).payload;
  }

  if (action.type === actionTypes.LLM_RUNS_CLEAR.SUCCESS) {
    return UNINITIALISED;
  }

  return state;
}
